export * from './IconGift';
export { default as IconGift } from './IconGift';
